// @flow
import InfiniteScroll from 'react-infinite-scroller';

import CatalogItem from '@components/ringSearch/CatalogItem';

import css from '@styles/ringSearch';

import type { SettingSearchResultType } from '@types/setting';

type TProps = {
  items: Array<SettingSearchResultType>,
  allowGettingMoreResults: boolean,
  onInfiniteLoad: () => void,
  isLoading: boolean
};

const loadingIcon = '/images/loading-diamond.gif';

function Loading () {
  return (
    <div className={css.loading}>
      <div>
        <img src={loadingIcon} alt="Loading icon" />
      </div>
      <p>Loading settings...</p>
    </div>
  );
}

function SearchResults ({
  items,
  allowGettingMoreResults,
  onInfiniteLoad,
  isLoading
}: TProps) {
  return (
    <InfiniteScroll
      loadMore={onInfiniteLoad}
      hasMore={allowGettingMoreResults}
      className={css.container}
      threshold={500}
      initialLoad={false}>
      {items.map((item) => <CatalogItem key={item.vendor_sku} item={item} />)}
      {isLoading && <Loading key="loading" />}
    </InfiniteScroll>
  );
}

export default SearchResults;
